// @flow
/* eslint-disable max-len */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const UploadIcon = (props) => (
  <SvgIcon width="21" height="20" viewBox="0 0 21 20">
    <g id="Registration-UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M19.5 13V14.2C19.5 15.8802 19.5 16.7202 19.173 17.362C18.8854 17.9265 18.4265 18.3854 17.862 18.673C17.2202 19 16.3802 19 14.7 19H6.3C4.61984 19 3.77976 19 3.13803 18.673C2.57354 18.3854 2.1146 17.9265 1.82698 17.362C1.5 16.7202 1.5 15.8802 1.5 14.2V13M15.5 6L10.5 1M10.5 1L5.5 6M10.5 1V13"
        stroke="#00B7C1"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>{' '}
  </SvgIcon>
);

export default UploadIcon;
